import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/draft2digital': {
    width: 480,
    height: 512,
    paths: [
      {
        d: 'M480 398.1l-144 81.9v-64.2l-336 0.1c18.3-19.1 84.5-87.8 161.1-174.8 32.6-37.2 78-83.3 69.7-127.6-5.3-28.3-42.2-50.8-83.3-33.5-8.6 3.6-24.5 17.4-26.3 24.7 28.3 4.7 48 29.7 48 56.8 0 31.7-25.6 57.4-57.3 57.4-37.3 0-62.2-34.1-56.7-67.1 1.2-7.9 5.1-26.8 18.2-47.7 14.9-23.9 45.2-54.9 104.3-67.3 103.8-21.7 161.6 36.6 166 41.2 28.9 29.9 48 90.7 12.8 153.3-30 53.4-81 114.3-111.8 149.3h91.3v-64.7zM369.9 371v54.4l47.1-27.2zM134.2 161.4c0-12.3-10-22.4-22.4-22.4-12.4 0-22.4 10-22.4 22.4 0 12.4 10 22.4 22.4 22.4 12.4 0 22.4-10 22.4-22.4zM82.5 380.5h114.4c17.6-19.2 91.5-100.8 128.5-166.7 36.6-65.1-5.8-113.3-5.8-113.3-14.2-14.9-36.9-36.2-82.2-38.3 6.8 5.5 16.9 16.9 24.3 35.7 11.9 30.3 6.7 69.6-28.4 112.7-53.1 65.2-125.2 142.5-150.8 169.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/draft2digital.js
// module id = 797
// module chunks = 0